import {
  ApiResponse,
  DeleteTermsOfUseFileRequest,
  InitOverrideFunction,
  TermsOfUseApi,
  TermsOfUseFileResponse,
  TermsOfUseGetByIdRequest,
  TermsOfUseResponse,
  UploadTermsOfUsePostRequest,
} from "../../../@api";

export class TermsOfUseApiService implements Omit<
  TermsOfUseApi,
  `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware"
> {
  constructor(private readonly api: TermsOfUseApi) {}

  public acceptCurrentTermsOfUsePatch(initOverrides?: RequestInit | InitOverrideFunction): Promise<string> {
    return this.api.acceptCurrentTermsOfUsePatch(initOverrides);
  }

  public deleteTermsOfUseFile(
    requestParameters: DeleteTermsOfUseFileRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.deleteTermsOfUseFile(requestParameters, initOverrides);
  }

  public getNewestTermsOfUse(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<TermsOfUseFileResponse | null | undefined> {
    return this.api.getNewestTermsOfUse(initOverrides);
  }

  public termsOfUseGetAll(initOverrides?: RequestInit | InitOverrideFunction): Promise<TermsOfUseResponse> {
    return this.api.termsOfUseGetAll(initOverrides);
  }

  public termsOfUseGetById(
    requestParameters: TermsOfUseGetByIdRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<TermsOfUseFileResponse | null | undefined> {
    return this.api.termsOfUseGetById(requestParameters, initOverrides);
  }

  public uploadTermsOfUsePost(
    requestParameters?: UploadTermsOfUsePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.uploadTermsOfUsePost(requestParameters, initOverrides);
  }

  public uploadTermsOfUsePostRaw(
    requestParameters: UploadTermsOfUsePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.api.uploadTermsOfUsePostRaw(requestParameters, initOverrides);
  }
}
